import { graphql, useStaticQuery } from 'gatsby';

const useSacredArchitecturesJapan = () => {
  const data = useStaticQuery(graphql`
    query {
      allMdx(
        # filter: { frontmatter: { series: { eq: "Sacred Architectures" } } }
        filter: { frontmatter: { country: { eq: "Japan" } } }
        sort: { fields: [frontmatter___name], order: ASC }
      ) {
        nodes {
          frontmatter {
            name
            slug
            title
            series
            media
            size
            year
            city
            state
            country
          }
        }
      }
    }
  `);

  return data.allMdx.nodes;
};

export default useSacredArchitecturesJapan;
